import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Role } from 'src/app/interfaces/api/role';
import { ApiService } from 'src/app/services/core/api.service';
import { environment } from 'src/environments/environment';

type QueryParams = Record<string, string | number | boolean | Date | Array<string | number | boolean | Date> | object>;

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  collection = "Role";
  collectionPath = "roles";
  roles: Role[] = [];
  apiUrl = environment.API_URL;

  constructor(
    private apiService: ApiService,
    public http: HttpClient,
  ) { }

  // Roles

  getRoles(query: QueryParams = {}): Observable<Role[]> {

    return this.apiService.getCollection(this.collectionPath, "", query);
  }

  addRole(role: Role): Observable<any> {
    return this.apiService.postCollectionData(this.collectionPath, '', role);
  }

  updateRole(role: Role): Observable<any> {
    return this.apiService.updateCollectionItem(this.collectionPath, role);
  }
}
